export default "__VITE_ASSET__CJjT4JvO__"